<div class="card p-3">

    <h1 class="mb-4">Disclaimer</h1>

    Synectics plc makes every reasonable effort to maintain the accuracy of the information displayed across its website. However we make no representation, nor offer any guarantee, warranty or assurance of any kind that the information on our website is completely accurate or fully up-to-date. Synectics plc accepts no responsibility for any losses which a third party visitor to this website may suffer from relying, in whole or in part or directly or indirectly, on any information contained on any part of our website.

</div>
